import messages from './downloadlayers-modal-translations';
import * as $ from 'jquery';

export default {
    name: 'downloadlayers-modal',
    i18n: {
        messages,
    },
    props: {
        show: {
            type: Boolean 
        },
        layersItem: {
            type: Array,
        },
    },
    methods: {    
        dismiss: function () {
            this.$emit('closeDownloadModal');
        },
        showDownloadOptions: function(item){
            $('#list-downloadlayers').css('display', 'none');
            $('#desc').css('display', 'none');
            $('#body-download').css('display', 'block');
            $('#input-download-name').val(item.serverName);
            $('#input-businessId').val(item.businessId);
            download_layer = item;            
        },
        hideDownloadOptions: function(){
            $('#list-downloadlayers').css('display', 'block');
            $('#desc').css('display', 'block');
            $('#body-download').css('display', 'none');
            $('#input-download-name').val('');
            $('#input-businessId').val('');
        },
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/downloadlayers-modal/downloadlayers-modal.js